import {SvgIcon, SvgIconProps} from "@mui/material";

export const RectangleIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <rect
            x="4"
            y="6"
            width="16"
            height="12"
            rx="1"
            ry="1"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        />
    </SvgIcon>
);
